import {
  ArrowRight,
  ArrowUpRight,
  Facebook,
  Instagram,
  Radio,
  Sparkles,
  Video,
} from 'lucide-react';
import { imgAdoracion, imgCongregacionWide } from '../assets';
import { Layout } from '../components/Layout';
import { PageHero } from '../components/PageHero';
import { useReveal } from '../hooks';
import { facebookUrl, instagramUrl, services } from '../site';

const liveTimes = services.filter((service) => service.title === 'Servicio general');

const verses = [
  {
    text: 'Lámpara es a mis pies tu palabra, y lumbrera a mi camino.',
    reference: 'Salmos 119:105',
  },
  {
    text: 'Por nada estéis afanosos… y la paz de Dios, que sobrepasa todo entendimiento, guardará vuestros corazones.',
    reference: 'Filipenses 4:6-7',
  },
  {
    text: 'No temas, porque yo estoy contigo; no desmayes, porque yo soy tu Dios que te esfuerzo.',
    reference: 'Isaías 41:10',
  },
];

export function MensajesPage() {
  useReveal();

  return (
    <Layout>
      <PageHero
        kicker="Mensajes"
        title={<>Palabra que <em>edifica</em> el corazón.</>}
        lead="Cada semana compartimos un mensaje de fe y esperanza. Mira las transmisiones en vivo y los mensajes recientes en nuestro Facebook."
        image={imgAdoracion}
      >
        <a className="button button-gold" href={facebookUrl} target="_blank" rel="noopener noreferrer">
          <Facebook size={18} aria-hidden="true" /> Ver mensajes en Facebook
        </a>
      </PageHero>

      <section className="section-space" aria-labelledby="live-title">
        <div className="page-shell">
          <div className="section-heading reveal">
            <div>
              <p className="section-kicker">
                <span /> En vivo y en directo
              </p>
              <h2 id="live-title">Acompáñanos desde donde estés.</h2>
            </div>
            <p>
              Transmitimos nuestros servicios por Facebook. Conéctate, comenta y
              comparte el mensaje con alguien que lo necesite.
            </p>
          </div>

          <div className="live-layout">
            <a
              className="live-card reveal"
              href={facebookUrl}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Ver las transmisiones en vivo de Tercer Cielo en Facebook"
            >
              <div className="live-card-topline">
                <span className="live-badge">
                  <Radio size={17} aria-hidden="true" /> En vivo por Facebook
                </span>
                <ArrowUpRight size={22} aria-hidden="true" />
              </div>
              <h3>Transmisiones de los servicios</h3>
              <p>Mira los servicios completos, mensajes recientes y momentos de la casa.</p>
              <ul className="live-schedule">
                {liveTimes.map((service) => (
                  <li key={`${service.day}-${service.time}`}>
                    <Video size={17} aria-hidden="true" />
                    <span>
                      {service.day} <strong>{service.time}</strong>
                    </span>
                  </li>
                ))}
              </ul>
              <span className="live-cta">
                Abrir Facebook <ArrowUpRight size={18} aria-hidden="true" />
              </span>
            </a>

            <div className="live-side">
              <a
                className="social-card social-card-instagram reveal"
                href={instagramUrl}
                target="_blank"
                rel="noopener noreferrer"
              >
                <span className="social-card-icon">
                  <Instagram size={26} aria-hidden="true" />
                </span>
                <div>
                  <strong>Instagram</strong>
                  <p>Fragmentos, fotos y anuncios de la semana.</p>
                </div>
                <ArrowUpRight size={20} aria-hidden="true" />
              </a>
              <figure className="live-photo reveal">
                <img
                  src={imgCongregacionWide}
                  alt="La congregación de Tercer Cielo reunida durante un servicio"
                  loading="lazy"
                />
                <figcaption>
                  <Sparkles size={16} aria-hidden="true" /> Momentos que marcan la casa
                </figcaption>
              </figure>
            </div>
          </div>
        </div>
      </section>

      <section className="verses-section section-space" aria-labelledby="verses-title">
        <div className="page-shell">
          <div className="section-heading reveal">
            <div>
              <p className="section-kicker section-kicker-light">
                <span /> Palabra para hoy
              </p>
              <h2 id="verses-title">Lleva un versículo contigo.</h2>
            </div>
          </div>
          <div className="verses-grid">
            {verses.map((verse) => (
              <blockquote className="verse-card reveal" key={verse.reference}>
                <p>“{verse.text}”</p>
                <cite>{verse.reference}</cite>
              </blockquote>
            ))}
          </div>
        </div>
      </section>

      <section className="cta-band" aria-labelledby="messages-cta-title">
        <div className="page-shell cta-band-inner reveal">
          <h2 id="messages-cta-title">El mensaje se vive mejor en casa.</h2>
          <p>Nada como estar presente: adoración, comunión y oración.</p>
          <div className="cta-band-actions">
            <a className="button button-light" href="/visita/">
              Planifica tu visita <ArrowRight size={18} aria-hidden="true" />
            </a>
            <a
              className="button button-ghost"
              href={facebookUrl}
              target="_blank"
              rel="noopener noreferrer"
            >
              Síguenos en Facebook <ArrowUpRight size={18} aria-hidden="true" />
            </a>
          </div>
        </div>
      </section>
    </Layout>
  );
}
